import React from "react";
import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

interface HelpTooltipIconProps {
  /** The button's accessible name, e.g. "About Source Properties". */
  label: string;
  /** The explanation, shown on hover or focus and announced as the description. */
  help: string;
  testId?: string;
}

/**
 * A small info icon that explains its neighbour in a hover/focus tooltip.
 *
 * A real button so keyboard and screen-reader users reach it; the tooltip
 * describes it rather than naming it, so the help text is announced.
 */
const HelpTooltipIcon: React.FC<HelpTooltipIconProps> = ({
  label,
  help,
  testId,
}) => (
  <Tooltip title={help} describeChild arrow placement="top">
    <IconButton
      size="small"
      aria-label={label}
      sx={{ p: 0.25, color: "#adb5bd", cursor: "help" }}
      data-testid={testId}
    >
      <InfoOutlined sx={{ fontSize: 14 }} />
    </IconButton>
  </Tooltip>
);

export default HelpTooltipIcon;
